import { combineReducers } from 'redux';
import Filters from './filters';
import Register from './register';
import UI from './ui';

const rootReducer = combineReducers({
  Filters,
  Register,
  UI,
});

export default rootReducer;
